import React from 'react';
import DropdownItem from '@/components/DropdownItem';
import { userSearchableIcon } from '../constants';

const UserSearchableTool = ({ divider, onClick, searchable }) => (
  <DropdownItem
    divider={divider}
    icon={userSearchableIcon(searchable)}
    textId={searchable ? 'actions.searchable.not' : 'actions.searchable'}
    onClick={onClick}
  />
);

export default UserSearchableTool;
